module.exports = __webpack_public_path__ + "img/house9b.e71fed65.jpg";